import { createApp } from 'vue';
import App from './App.vue';
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import router from './router';
import { ElMessage } from 'element-plus'
import { Quasar } from 'quasar'
import quasarUserOptions from './quasar-user-options.js'
import 'quasar/dist/quasar.css'

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requireLogin)){  // 判断该路由是否需要登录权限
      if (sessionStorage.getItem('loginInfo')) {  // 判断当前用户的登录信息loginInfo是否存在
        next();
      } else {
        ElMessage({
            type: 'warning',
            message: '请登陆后在访问页面！！',
            })
        next({
          path: '/Login'
        })
      }
    }else {
      next();
    }
  
  })

createApp(App).use(ElementPlus,Quasar, quasarUserOptions).use(router).mount('#app');